import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { processData } from '../../../data/services/serivceProcessData';
import { estimationData } from '../../../data/order/serviceEstimationData';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { toast } from 'react-toastify';

export default function ServicePaymentPage() {
    const navigate=useNavigate();
    const {id}=useParams();
    const estimation=estimationData.find((e)=>e.estimationId===id);
    const process=processData.find((p)=>p.serviceId===estimation.serviceId);
    const [selectedMethod, setSelectedMethod] = useState("Credit / Debit Card");
    const methods = [
       "Credit / Debit Card",
       "UPI Payment",
       "Net Banking",
       "Cash On Delivery",
     ];
    const [cardDetails, setCardDetails] = useState({
     number: "",
     holder: "",
     expiry: "",
     cvv: "",
   });
   const [upiId, setUpiId] = useState("");
   const [selectedBank, setSelectedBank] = useState("");
   
    const additionalChargesTotal = process?.invoice?.additionalCharges?.reduce(
        (sum, item) => sum + (item.amount || 0),
          0
        ) || 0;

    const subtotal = (estimation?.total_service_cost || 0) + additionalChargesTotal;

    const discountPercent = estimation?.discount_percent || 0;
    const discountAmount = (subtotal * discountPercent) / 100;

    const total = subtotal - discountAmount;

    const handleConfirmPayment = () => {
    if (selectedMethod === "Credit / Debit Card") {
      if (
        !cardDetails.number ||
        !cardDetails.holder ||
        !cardDetails.expiry ||
        !cardDetails.cvv
      ) {
        toast.error("Please fill all card details before proceeding.");
        return;
      }
    } else if (selectedMethod === "UPI Payment") {
      if (!upiId) {
        toast.error("Please enter your UPI ID before proceeding.");
        return;
      }
    } else if (selectedMethod === "Net Banking") {
      if (!selectedBank) {
        toast.error("Please select your bank before proceeding.");
        return;
      }
    }
    toast.success("Payment confirmed successfully!");
    navigate(-1);
  }

  return (
    <section className='p-5 md:p-8 xl:p-10'>
      <div className="text-base md:text-lg xl:text:xl font-medium flex items-center flex-row space-x-1 mb-5"
        onClick={()=>navigate(-1)}>
        <MdOutlineKeyboardBackspace />
        <p>Confirm payment</p>
      </div>
      <div className='flex flex-col md:flex-row gap-5'>
      <div className='w-full md:w-1/2'>
        <h2 className="text-sm md:text-base xl:text-xl font-semibold mb-4">Payment Method</h2>
        <div className="flex flex-col xl:flex-row divide-x border border-red-800 justify-between">
        {methods.map((method) => (
          <div
            key={method}
            onClick={() => setSelectedMethod(method)}
            className={`px-4 py-2  cursor-pointer text-sm xl:text-base font-medium transition-all duration-200 ${
              selectedMethod === method
                ? "bg-[#A63F40] text-white border-[#A63F40]"
                : "bg-white text-gray-700"
            }`}
          >
            {method}
          </div>
        ))}
        </div>
      
     
      {selectedMethod === "Credit / Debit Card" && (
        <div className="mt-4 grid grid-cols-1 gap-4 border border-gray-300 shadow-md rounded px-5 py-5">
          <input
            type="text"
            placeholder="Card Number"
            value={cardDetails.number}
            onChange={(e) => setCardDetails({ ...cardDetails, number: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="text"
            placeholder="Card Holder Name"
            value={cardDetails.holder}
            onChange={(e) => setCardDetails({ ...cardDetails, number: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="text"
            placeholder="Expiry Date (MM/YY)"
            value={cardDetails.expiry}
            onChange={(e) => setCardDetails({ ...cardDetails, number: e.target.value })}
            className="border rounded px-3 py-2 w-full border-gray-500 focus:outline-none"
          />
          <input
            type="password"
            placeholder="CVV"
            value={cardDetails.cvv}
            onChange={(e) => setCardDetails({ ...cardDetails, number: e.target.value })}
            className="border rounded border-gray-500 focus:outline-none px-3 py-2 w-full"
          />
        </div>
      )}

      {selectedMethod === "UPI Payment" && (
        <div className="mt-4 border border-gray-300 shadow-md rounded px-5 py-5">
          <input
            type="text"
            placeholder="Enter UPI ID"
            value={upiId}
            onChange={(e) => setUpiId(e.target.value)}
            className="border rounded border-gray-500 focus:outline-none px-3 py-2 w-full"
          />
          <button className="bg-[#A63F40] w-full mt-3 py-2 text-center text-white rounded-md text-xs md:text-sm xl:text-base">Verify</button>
        </div>
      )}

      {selectedMethod === "Net Banking" && (
        <div className="mt-4 border border-gray-300 shadow-md rounded px-2 py-5">
          <select 
            value={selectedBank}
            onChange={(e) => setSelectedBank(e.target.value)}
            className="border border-gray-500 focus:outline-none rounded px-3 py-2 w-full text-xs md:text-sm xl:text-base">
            <option value="">Select Bank</option>
            <option>HDFC Bank</option>
            <option>ICICI Bank</option>
            <option>State Bank of India</option>
            <option>Axis Bank</option>
          </select>
        </div>
      )}

      {selectedMethod === "Cash On Delivery" && (
        <div className="mt-4 text-sm xl:text-base text-gray-600 border border-gray-300 shadow-md rounded px-2 py-5">
          <p className="text-center">Pay with cash when your order is delivered to your doorstep.</p>
        </div>
      )}
      </div>

      <div className='w-full md:w-1/2 space-y-4'>
      <h2 className="text-sm md:text-base xl:text-xl font-semibold mb-4 mt-6">Payment Summary</h2>
      <div className="w-full xl:w-2/3 border border-gray-300 shadow-md rounded px-5 py-5 grid grid-cols-2 gap-x-2 gap-y-2 text-sm md:text-sm xl:text-base">
          <p>Total Item:</p>
          <p>{estimation.estimation.length>0 ? estimation.estimation.length : "-"}</p>
          <p>Subtotal:</p>
          <p>₹{subtotal.toLocaleString()}</p> 
          <p>Discount percent:</p>
          <p>{estimation.discount_percent} %</p>
          <p>Discount Amount:</p> 
          <p>-₹{discountAmount.toLocaleString()}</p>
          <hr className="col-span-2"/>
          <p>Total:</p>
          <p>₹{total.toLocaleString()}</p>
      </div>
      <button 
        className='px-4 py-2 text-xs md:text-sm xl:text-base bg-[#A63F40] rounded-md text-white ml-16 md:ml-20 xl:ml-24'
        onClick={handleConfirmPayment}
      >
            Confirm & Pay
      </button>
      </div>
      </div>
    </section>
  )
}
